import React from "react";
import { MCard } from "components/Shared";
import { DataVerifiedCaseFormResult } from "interfaces/Mueller.Business.Models";
import { classes } from "components/Utility";

interface Props {
  verifiedFormResults?: DataVerifiedCaseFormResult[],
  redTitle?: boolean;
}

const HiddenFromQAMessage = ({ verifiedFormResults = [], redTitle = false }: Props) => {
  let singleFormMessage: string = null;
  let passedMessage: string = null;
  let failedMessage: string = null;
  let passedForms = verifiedFormResults.filter(r => r.formCanBeHiddenFromQa);
  let failedForms = verifiedFormResults.filter(r => !r.formCanBeHiddenFromQa);


  if (verifiedFormResults.length === 0) {
    singleFormMessage = "This form was reviewed by AI and was hidden from QA review."
  }
  if (passedForms.length) {
    passedMessage =
      `AI Verification Check: Passed. The following forms have been reviewed by AI and do not need to be reviewed by QA: `
      + passedForms.map(f => f.availFormName).join("; ");
  }
  if (failedForms.length) {
    failedMessage =
      `AI Verification Check: Failed. The following forms have been reviewed by AI and need to be reviewed by QA: `
      + failedForms.map(f => f.availFormName).join("; ");
  }

  // right now only one of these messages will show, so we didnt really need this
  // but i could see verifications being improved in the future where some pass and some fail
  const stringsWithBreaks = [singleFormMessage, passedMessage, failedMessage].filter(Boolean).flatMap((s, i) => i ? [<br key={i} />, s] : [s])

  return (
    <MCard title="AI Results" className={classes("ai-form-results", redTitle && "red-title")}>
      {stringsWithBreaks}
    </MCard>
  );
};

export default HiddenFromQAMessage;
